(function () {
    "use strict";

    /********************************************************************************************************/
    /**** @CC This is the default direct to customer behaviour                                           ****/
    /********************************************************************************************************/

    cip_Entity.clientHomePageUrl = "https://www.tsb.co.nz/";
    cip_Entity.previousSelectedPageId = null;
    cip_Entity.hasSubmitted = false;

    cip_Entity.createNextButtonText = function (entityName, formId, isFirstPageSelected, isLastNonRestrictedPageSelected, isReadyToFinish, isInterviewComplete, treatInterviewAsCompletedOnLoad) {
        var text = null;

        if (isInterviewComplete == false) {
            if (isLastNonRestrictedPageSelected == true && isReadyToFinish == true) {
                text = 'Submit';
            } else {
                text = 'Next';
            }
        } else {
            text = 'Next';
        }

        return text;
    };

    cip_Entity.createPreviousButtonText = function (entityName, formId, isFirstPageSelected, isLastNonRestrictedPageSelected, isReadyToFinish, isInterviewComplete, treatInterviewAsCompletedOnLoad) {
        var text = null;

        if (isFirstPageSelected == false) {
            text = 'Previous';
        }

        return text;
    };

    cip_Entity.createSaveButtonText = function (entityName, formId, isFirstPageSelected, isLastNonRestrictedPageSelected, isReadyToFinish, isInterviewComplete, treatInterviewAsCompletedOnLoad) {
        return 'Save and Exit';
    };

    cip_Entity.showApplicationSaveAsDialog = function(entityName, formId, application){
        cc_UI.createSimpleDialog({
            id : cip_SaveAsDialog.id(),
            title : cip_SaveAsDialog.title(),
            content : '<p><b>To save your progress, we\'ll need the following details.</b> We\'ll send you a link so that you can pick up where you left off later.<p><label id="saveAsEmailLabel"><span class="emailLabel" style="width:130px;" >Email Address</span><input name="saveAsEmail" class="form-control" type="text" style="margin-top: 5px;" /></label><label id="saveAsMobilePhoneNumberLabel"><span class="mobilePhoneNumberLabel" style="width:130px;">Mobile Phone</span><input name="saveAsMobilePhoneNumber" class="form-control" type="text" style="margin-top: 5px;" /></label>',
            width : screen.width < cc_UI.viewportMinimumWidth ? screen.width : cip_SaveAsDialog.width(),
            okText : cip_SaveAsDialog.okText,
            firstOpen : function () {
                if(application.customers && application.customers.length > 0){
                    var primaryCustomer = application.customers[0];

                    cip_SaveAsDialog.populate({
                        email : primaryCustomer.email,
                        mobilePhoneNumber : primaryCustomer.mobilePhoneNumber
                    });
                }
            },
            ok : function () {
                var saveAs = cip_SaveAsDialog.unpopulate();

                var validateSaveAs = function(saveAs){
                    var email = saveAs.email;
                    var mobilePhoneNumber = saveAs.mobilePhoneNumber;

                    var errors = [];

                    // email address validator
                    if(email){
                        var emailExpression = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
                        if(emailExpression.test(email) == false) {
                            errors.push({description: encodeURIComponent(saveAs.email) + ' is not a valid email address'});
                        }
                    }else{
                        errors.push({description: 'an email address is required'});
                    }

                    // mobile phone number validator
                    if(mobilePhoneNumber){
                        var mobilePhoneExpression = /^((\+[0]{0,2}64)(2|85|86|89|96)|02)\d{6,}$/;
                        mobilePhoneNumber = mobilePhoneNumber.replace(/ /g,'').replace(/\+[0]{0,2}64/, '0');

                        if(mobilePhoneExpression.test(mobilePhoneNumber) == false) {
                            errors.push({description: encodeURIComponent(saveAs.mobilePhoneNumber) + ' is not a valid mobile phone number'});
                        }
                    }else{
                        errors.push({description: 'a mobile phone number is required'});
                    }

                    return errors;
                };

                var errors = validateSaveAs(saveAs);

                if(errors.length === 0){
                    cc_UI.hideDialog(cip_SaveAsDialog.id());
                    cc_EntityIntegration.saveUnsubmittedApplicationToCompleteLater(cc_Config.applicationId, saveAs.email, saveAs.mobilePhoneNumber, function(){
                        cc_UI.showNotificationDialog(
                            "Your application has been saved.<br><br>" +
                            "Instructions on how to continue this application have been sent to your email address.",
                            "Application Saved", function(){
                                window.location.href = cip_Entity.clientHomePageUrl;
                            }, screen.width < cc_UI.viewportMinimumWidth ? screen.width : 450
                        );
                    });
                }else{
                    cc_UI.attachErrorsToDialog(cip_SaveAsDialog.id(), errors);
                }
            }
        });
    };

    cip_Entity.showSendSmsCodeDialog = function (entityName, formId, data, successCallback) {
        cc_UI.createSimpleDialog({
            id: cip_SendSmsCodeDialog.id(),
            title: cip_SendSmsCodeDialog.title(),
            content: cip_SendSmsCodeDialog.content(data),
            width: screen.width < cc_UI.viewportMinimumWidth ? screen.width : cip_SendSmsCodeDialog.width(),
            okText: cip_SendSmsCodeDialog.okText,
            closable: false,
            ok: function () {
                $("#" + cip_SendSmsCodeDialog.id()).dialog('close').hide();
                successCallback();
            }
        });
    };

    cip_Entity.showActivateUsingSmsCodeDialog = function (entityName, formId, data) {
        var resendButtonText = "Resend SMS Activation Code";

        cc_UI.createSimpleDialog({
            id: cip_ActivateUsingSmsCodeDialog.id(),
            title: cip_ActivateUsingSmsCodeDialog.title(),
            content: cip_ActivateUsingSmsCodeDialog.content(data),
            width: screen.width < cc_UI.viewportMinimumWidth ? screen.width : cip_ActivateUsingSmsCodeDialog.width(),
            okText: cip_ActivateUsingSmsCodeDialog.okText,
            closable: false,
            firstOpen: function () {
                $("button:contains(" + resendButtonText + ")").addClass("btn-default").removeClass("btn-primary");
            },
            ok: function () {
                var activateUsingSmsCode = cip_ActivateUsingSmsCodeDialog.unpopulate();

                cc_EntityIntegration.activateApplicantSessionUsingSmsCode(activateUsingSmsCode.smsCode);
            },
            additionalButtons: [{
                text: resendButtonText,
                action: function () {
                    cc_EntityIntegration.sendApplicantSessionActivationSmsCode(function () {
                        $("button:contains(" + resendButtonText + ")").hide(); // only allow one resend
                        cc_UI.showNotificationDialog("An activation code has been resent to your mobile phone.", "Sent SMS Activation Code");
                    });
                }
            }]
        });
    };

    cip_Entity.showActivateUsingCustomerDetailsDialog = function (entityName, formId, data) {
        cc_UI.createSimpleDialog({
            id: cip_ActivateUsingCustomerDetails.id(),
            title: cip_ActivateUsingCustomerDetails.title(),
            content: cip_ActivateUsingCustomerDetails.content(data),
            width: screen.width < cc_UI.viewportMinimumWidth ? screen.width : cip_ActivateUsingCustomerDetails.width(),
            okText: cip_ActivateUsingCustomerDetails.okText,
            closable: false,
            ok: function () {
                var customerDetails = cip_ActivateUsingCustomerDetails.unpopulate();

                cc_EntityIntegration.activateApplicantSessionUsingCustomerDetails(customerDetails.email, customerDetails.firstName, customerDetails.lastName, customerDetails.representativeName);
            }
        });
    };

    cip_Entity.handleUnavailableApplicantSession = function (entityName, formId) {
        cc_UI.createSimpleDialog({
            id: "unavailableApplicantSessionDialog",
            title: "Unauthorised Access",
            content: "",
            width: screen.width < cc_UI.viewportMinimumWidth ? screen.width : 450,
            closable: false,
            firstOpen: function () {
                cc_UI.attachErrorToDialog("unavailableApplicantSessionDialog",
                    "You are not allowed to access this page."
                );
            },
            ok: function () {
                window.location.href = cip_Entity.clientHomePageUrl;
            }
        });
    };

    cip_Entity.handleInvalidApplicantSmsCode = function (entityName, formId, data) {
        var message = null;
        if (data && data.tooManyFailedAttempts === 'true') {
            message = 'Too many failed attempts, please try again in a few minutes.';
        } else {
            message = 'You have entered an invalid activation code. Please check for any mistakes and try again.';
        }

        cc_UI.showErrorDialog(message, 'Invalid SMS Activation Code');
    };

    cip_Entity.handleInvalidApplicantCustomerDetails = function (entityName, formId, data) {
        var message = null;
        if (data && data.tooManyFailedAttempts === 'true') {
            message = 'Too many failed attempts, please try again in a few minutes.';
        } else {
            message = 'You have entered incorrect information. Please check for any mistakes and try again.';
        }

        cc_UI.showErrorDialog(message, 'Incorrect Information');
    };

    cip_Entity.onCleanAndRefresh = function (entityName, formId, application) {
        $("body").addClass(formId);
    };

    cip_Entity.onPreRendering = function (entityName, formId, application) {
        $('#cloudcase-page-navigator').affix({offset: {top: 0}});
    };

    cip_Entity.onPostRendering = function (entityName, formId, application) {
        $('.page_navigator_item a:contains(\()').not('[data-post-rendered]').html(function () {
            return $(this).attr('data-post-rendered', 'true').html().replace("(", "<br>(");
        });
    };

    cip_Entity.onPreFindingsAssessment = function (entityName, formId, application, continuation) {
        if ((cc_Model.anyLevelQuestionMap.ApplicationHalted && cc_Model.anyLevelQuestionMap.ApplicationHalted.concealed == true) || !cc_Model.anyLevelQuestionMap.ApplicationHalted) {
            if (!cip_Custom.shouldShowSpeakToExpert() || cip_Custom.isComplexLending()) {
                cc_UI.showConfirmDialog("Please confirm you would like to speak to an expert.", function () {
                    continuation();
                }, null, 'Confirm');
            } else if (cc_Model.anyLevelQuestionMap.OnboardingAdditionalCardholder1IdentityVerificationChoice || cc_Model.anyLevelQuestionMap.OnboardingAdditionalCardholder2IdentityVerificationChoice || cc_Model.anyLevelQuestionMap.OnboardingAdditionalCardholder3IdentityVerificationChoice) {
                cc_UI.showConfirmDialog("Are you sure you would like to submit your application to be added as an additional cardholder?", function () {
                    continuation();
                }, null, 'Submitting');
            } else {
                cc_UI.showConfirmDialog("Are you sure you would like to submit your application for a TSB " + cip_Custom.getApplicationType() + "?", function () {
                    continuation();
                }, null, 'Submitting');
            }
        } else {
            var title = 'Your Application';
            var message = "<b>Thanks for your application for a TSB " + cip_Custom.getApplicationType()  + ".</b><br/><br/>Unfortunately we are unable to offer you a " + cip_Custom.getApplicationType()  + " at this time.<br/><br/>" +
                "If you have any questions, please contact us on <b class = 'ui-dialog-phonelink'>0800 872 002</b>.";
            cc_UI.showNotificationDialog(message, title, function() {
                window.location.href = cip_Entity.clientHomePageUrl;
            });
        }
    };

    cip_Entity.onPostFindingsAssessment = function (entityName, formId, application) {
        var message = null;
        var title = null;
        cip_Entity.hasSubmitted = true;

        if (cip_Custom.isOnlineHomeLoan()) {
            if (!cip_Custom.shouldShowSpeakToExpert() || cip_Custom.isComplexLending()) {
                title = "We'll be in touch shortly";
                message = "One of our lending specialists will get in touch within three business days.";

                cc_UI.showNotificationDialog(message, title, function () {
                    window.location.href = cip_Entity.clientHomePageUrl;
                });
            } else {
                window.location.href = window.location.href.replace("/application", "/success");
            }
        } else {
            title = 'Next steps';
            message = "Thanks for your additional information.<br/><br/>" +
                "We'll review this and call you in a few days to finalise your application.<br/><br/>" +
                "If you've chosen to verify your ID in one of our branches, please do this as soon as possible.<br/><br/>" +
                "If you have any questions, please call us on <b>0800 872 002</b>.";

            cc_UI.showNotificationDialog(message, title, function () {
                window.location.href = cip_Entity.clientHomePageUrl;
            });
        }
    };

    cip_Entity.onPostFindingsReassessment = function (entityName, formId, application) {
    };

    cip_Entity.onPreGetQuestions = function (entityName, formId, application, task) {
    };

    cip_Entity.onPostChangedEnteredValue = function (entityName, formId, application, question, updatedEnteredValue) {
    };

    cip_Entity.onPostShowPage = function (entityName, formId, application, page) {
        if (cip_Entity.previousSelectedPageId != page.id) {
            cip_Entity.previousSelectedPageId = page.id;
        }
    };

    cip_Entity.init = function () {
        cc_UI.initViewpoint = function () {
            $("[name=viewport]").attr("content", "width=device-width, initial-scale=1.0, minimum-scale=1.0, viewport-fit=cover");
        };

        cc_UI.initViewpoint();
    };
})();